import { Box, Grid } from '@mui/material';
import { useState } from 'react';
import { WsColors, WsDrawer, WsTitleBanner } from 'wisestep-base';

import HarvestBotsList from '../Bots/HarvestBotsListing';
import HarvestBotDownloadMatchList from '../components/HarvestBotDownloadMatchList';
interface NativeSearchFormProps {
  jobBoardName?:
    | 'DICE_SEARCH'
    | 'TECH_FETCH'
    | 'CAREER_BUILDER'
    | 'MONSTER'
    | 'CW_JOBS'
    | 'CAREER_BUILDER_EDGE'
    | 'JOB_SITE'
    | 'JOB_SERVE'
    | 'CV_LIBRARY';
  onViewCvClick?: (candidateId: string) => Promise<void>;
}

const SourcingBots = ({ onViewCvClick, jobBoardName }: NativeSearchFormProps) => {
  const [openBotDownloadMatchDrawer, setOpenBotDownloadMatchDrawer] = useState<boolean>(false);
  const [type, setType] = useState<string>();
  const [harvestId, setHarvestId] = useState<string>();
  const handleOpenBotDownloadMatchDrawer = (type, harvestId) => {
    setHarvestId(harvestId);
    setType(type);
    setOpenBotDownloadMatchDrawer(true);
  };

  return (
    <Box borderRadius={1.5}>
      <WsTitleBanner title="Sourcing Bots" backButton={false} />
      <Grid item xs={6}></Grid>
      <Grid container bgcolor={WsColors.White}>
        <HarvestBotsList handleOpenBotDownloadMatchDrawer={handleOpenBotDownloadMatchDrawer} />
      </Grid>
      <WsDrawer
        size="large"
        title="Informatica"
        iconType="cross"
        open={openBotDownloadMatchDrawer}
        onClose={() => setOpenBotDownloadMatchDrawer(false)}
      >
        <HarvestBotDownloadMatchList
          onViewCvClick={onViewCvClick}
          type={type}
          harvestId={harvestId}
          jobBoardName={jobBoardName}
        />
      </WsDrawer>
    </Box>
  );
};

export default SourcingBots;
